module.exports = __webpack_public_path__ + "assets/img/The-Onset-Website-w540.3c8cb9e3.webp";